package com.essntl.features.proposal.ui.addeditproposal

import core.validation.Form
import core.validation.field.DateRangeField
import core.validation.field.Field
import core.validation.field.ListField
import core.validation.field.StringField
import core.validation.validator.*

class AddEditProposalValidation {
    val addEditProposalForm = AddEditProposalForm()
}

class AddEditProposalForm : Form() {
    val areas =
        ListField(NonEmptyListValidator)

    val title =
        StringField(NonEmptyValidator)

    val dateRange =
        DateRangeField(
            validators =
            arrayOf(
                DateDoubleValidator(firstValueRequired = true, secondValueRequired = true),
                DateRangeValidator(firstValueRequired = true, secondValueRequired = true),
            ),
        )

    override val fields: List<Field> =
        listOf(
            areas,
            title,
            dateRange,
        )
}
